/**
 * Categories Service
 * Business logic and API calls for categories
 */

import { BaseService } from './base.service'
import { 
  Category, 
  CreateCategoryDTO, 
  UpdateCategoryDTO,
  CategoryType,
  ID 
} from '../types'

export class CategoriesService extends BaseService {
  private readonly endpoint = '/api/categories'

  /**
   * Get all categories
   */
  async getAll(type?: CategoryType): Promise<Category[]> {
    const queryString = type ? this.buildQueryString({ type }) : ''
    return this.get<Category[]>(`${this.endpoint}${queryString}`)
  }

  /**
   * Get category by ID
   */
  async getById(id: ID): Promise<Category> {
    return this.get<Category>(`${this.endpoint}/${id}`)
  }

  /**
   * Get category with subcategories
   */
  async getWithSubcategories(id: ID): Promise<Category> {
    return this.get<Category>(`${this.endpoint}/${id}/with-subcategories`)
  }

  /**
   * Create new category
   */
  async create(data: CreateCategoryDTO): Promise<Category> {
    return this.post<Category, CreateCategoryDTO>(this.endpoint, data)
  }

  /**
   * Update category
   */
  async update(id: ID, data: Partial<UpdateCategoryDTO>): Promise<Category> {
    return this.put<Category, Partial<UpdateCategoryDTO>>(`${this.endpoint}/${id}`, data)
  }

  /**
   * Delete category
   */
  async delete(id: ID): Promise<void> {
    return this.delete<void>(`${this.endpoint}/${id}`)
  }
}

// Export singleton instance
export const categoriesService = new CategoriesService()

